import { Link } from 'react-router-dom';
import { Shield, Linkedin, Twitter, Github, Mail } from 'lucide-react';

const footerLinks = {
  products: [
    { label: 'TrackOtic', path: '/products/trackotic' },
    { label: 'All Products', path: '/products' },
  ],
  services: [
    { label: 'IoT Solutions', path: '/services#iot' },
    { label: 'Cybersecurity', path: '/services#cybersecurity' },
    { label: 'Cloud Infrastructure', path: '/services#cloud' },
    { label: 'Embedded Systems', path: '/services#embedded' },
  ],
  company: [
    { label: 'About Us', path: '/about' },
    { label: 'Case Studies', path: '/case-studies' },
    { label: 'Contact', path: '/contact' },
    { label: 'Client Portal', path: '/login' },
  ],
};

const socialLinks = [
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Github, href: '#', label: 'GitHub' },
  { icon: Mail, href: 'mailto:contact@sentinelxtech.com', label: 'Email' },
];

export default function Footer() {
  return (
    <footer 
      data-testid="footer"
      className="bg-gray-50 border-t border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary rounded-lg flex items-center justify-center">
                <Shield className="h-5 w-5 text-white" />
              </div>
              <span className="font-heading text-xl font-bold text-gray-900">
                Sentinel<span className="text-primary">X</span>
              </span>
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed mb-4 max-w-sm">
              Building intelligent IoT solutions for secure and compliant delivery systems. 
              Our flagship product <strong>TrackOtic</strong> enables real-time cold chain 
              monitoring for pharmaceuticals.
            </p>
            <div className="text-sm text-gray-600 mb-4">
              <p className="font-medium text-gray-900">SentinelX Technology Pvt Ltd</p>
              <p>Villa No 97, Basement 3, Block 3</p>
              <p>Charmwood Village, Faridabad, Haryana</p>
              <p>contact@sentinelxtech.com</p>
            </div>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-white border border-gray-200 rounded-lg flex items-center justify-center text-gray-500 hover:text-primary hover:border-primary transition-colors"
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading font-semibold text-gray-900 mb-4">
              Products
            </h4>
            <ul className="space-y-3">
              {footerLinks.products.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-gray-900 mb-4">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-gray-900 mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} SentinelX Technology Pvt Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-500">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-primary transition-colors">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
